export const StoreEntities = {
  MenuNavigations: '1',
  ProductTags: '2',
  DocumentRepositories: '3',
  ProductImages: '4',
  Products: '5',
  ReceiptTemplates: '6',
  UserImage: '7',
  ProductSKUs: '8',
  ProductImports: '9',
  StockOrders: '10',
  InventoryTakes: '11',
  SalesOrder: '12',
  CustomerImports: '13',
  GeneralProductImports: '15'
}

export const PkgFeatures = {
  InventoryManagement: 5, // // all inventory menus for management
  AwardWinningSupport: 6,
  ReportingAndAnalytics: 7, // all reporting other than adv inventory
  UnlimitedProductsUsers: 10,
  Promotions: 11,
  MultiOutletsRetailManagement: 13,
  APIAccess: 14,
  CustomisedOnboarding: 17,
  ChatSupport: 20,
  PhoneSupport: 21,
  RetailPOS: 22,
  InStoreLoyalty: 25,
  AdvancedInventoryReports: 26, // in reporting --> inventory movement
  CustomUserRoles: 27
}
